// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "actioncable" + "-" + "08540a6d2e1894652ebe" + ".digested.js";
};